export const SeawardEventBusTopicsConstants = {
    SET_WAKE_BUTTON_STATE: 'seaward:set-wake-button-state',
    WAKE_BUTTON_CLICKED: 'seaward:wake-button-clicked',
    LOGOUT: 'seaward:logout',
    LOGIN: 'seaward:login',
    LOGOUT_ACTION: 'seaward:logout-action',
    TOOL_SWITCH: 'seaward:tool-switch',
    HIDE_MENU: 'seaward:hide-menu',
    SHOW_NOTIFICATION_MODAL: 'seaward:show-notification-modal',
    PUSH_NOTIFICATION_EVENT: 'seaward:push-notification-event',
    DISPLAY_BLUETOOTH_PAIRING_MODAL: 'seaward:display-bluetooth-pairing-modal',
    BLUETOOTH_PAIRING_MODAL_RESULT: 'seaward:bluetooth-pairing-modal-result',
}
